import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { ContractorDto } from './contractor.dto';
import { ContractorRegionDto } from '../../contractor-region/dto/contractor-region.dto';
import { ContractorUserDto } from '../../contractor-user/dto/contractor-user.dto';

/**
 * Response of the composite contractor routes: the contractor with its
 * region and bumper links, plus the regions that were unlinked by this
 * request so the admin can warn the operator.
 */
export class ContractorFullDto extends ContractorDto {
  @ApiProperty({ type: () => [ContractorRegionDto] })
  @Expose()
  contractorRegions!: ContractorRegionDto[];

  @ApiProperty({ type: () => [ContractorUserDto] })
  @Expose()
  contractorUsers!: ContractorUserDto[];

  @ApiProperty({
    type: [String],
    description: 'Region ids removed from the contractor by this request.',
  })
  @Expose()
  removedRegionIds!: string[];
}
